import { Groups, Users, ThingType, PlatformUserAccess } from "./route-components";
const { base_url } = require("common/HttpClient/http-client");

const PLATFORM_ADMIN_SERVICE_V1 = "platform-admin-service/v1";

const INFRAMARK_CONSTANTS = {
  thingTypes: {
    Customer: "Customer",
    Site: "Location",
    "Process Area": "Area",
    "Edge Node": "Edge Node",
    Equipment: "Equipment",
    Control: "Metric",
    Others: "Others",
  },
  assets: {
    edgeNodeTypes: {
      edgeNode: "EDGENODE",
      device: "DEVICE",
      metric: "METRIC"
    },
    tableHeaders: {
      properties: [
        "Key",
        "Value",
        "Data Type",
        "",
      ],
    },
    tableRowKeys:{
      latestValue: "Latest Value",
    },
    labels: {
      properties: "Properties",
      propertiesNotAvailable: "Properties not available",
      tagDetails: "Tag Details",
      communicationHealth: "Communication Health",
      edgeNode: "Edge Node",
      device: "Device",
      online: "Online",
      offline: "Offline",
      lastMessagePrefix: "Last Data Message:",
      dataNotFound: "Data not found",
      edgeNodeLastMessageTooltip: "Last NDATA message receieved from edge node",
      deviceLastMessageTooltip: "Last DDATA message receieved from device",
      refreshStatusToolTip: "Refresh communication health status and timestamps"
    },
    toast: {
      sensorDataFetchSuccess: "Communication health data loaded successfully.",
      latestValueFetchSuccess: "Latest value loaded successfully.",
    },
    tagDetails: [
      { key: "lastCommunication", label: "Last Communication:" },
      { key: "communicationStatus", label: "Communication Status:" },
      { key: "latestValue", label: "Latest Value:" },
      { key: "sourcePath", label: "Source Path:" },
    ],
    tabs: {
      alerts: {
        key: "alerts",
        value: "Alarms",
      },
      assets: {
        key: "assets",
        value: "Assets",
      },
      payload: {
        key: "payload",
        value: "Payload",
      },
    },
    constants: {
      propertyDataTypes: [
        "TEXT",
        "INT",
        "FLOAT",
        "DATE",
        "BIGINT",
        "DOUBLE PRECISION",
        "BOOLEAN",
      ],
    },
    services: {
      assets: "/things",
      assetHierarchy: "/things/thingsByUserId",
      levelByHierarchy: "/spb-birth-service/nodes/hierarchy/",
      searchAsset: "/things/search/",
      assetsByUserAccess: "/things/thingsByUserId",
      assetDetails: "/spb-birth-service/nodes/details/",
      assetTypes: "/things/type",
      assetTypeDetails: "/things/type/",
      assetImage: "/things/image/imageid/",
      assetTypeImages: "/things/image/list/typeid/",
      createAsset: "/things/create",
      updateAsset: "/things/",
      assetTypeCategories: "/category/thingType/",
      assetTypeCategoryDetails: "/category/",
      childrenCloudHeirarchy: "/platform-admin-service/v1/context-nodes/",
      cloudHierarchyDomains: "/platform-admin-service/v1/context-nodes",
      nodeById: "/platform-admin-service/v1/context-nodes/",
      cloudNodeTypesReferenceData: "/platform-admin-service/v1/reference-data/node-types",
      addUpdateCloudNode: "/platform-admin-service/v1/context-nodes",
      lastMessageAndLatestValue: "/sensor-data-service/v1/sensordata/latest-snapshot",
    },
  },
  alerts: {
    tableHeaders: {
      condition: [
        "Sequence",
        "Information",
        "Category",
        "Condition",
        "Active",
        "",
      ],
      configuration: [
        "Alarm Id",
        "Alarm Label",
        "Threshold",
        "Alarm Condition",
        "Priority",
        "Notify",
        "",
      ],
    },
    constants: {
      CONFIGURATIONVIEW: "CONFIGURATIONVIEW",
      CONFIGURATIONPREVIEW: "CONFIGURATIONPREVIEW",
      CREATECONFIGURATIONVIEW: "CREATECONFIGURATIONVIEW",
      EDITCONFIGURATIONVIEW: "EDITCONFIGURATIONVIEW",
      CONDITIONPREVIEW: "CONDITIONPREVIEW",
      EDITCONDITIONSVIEW: "EDITCONDITIONSVIEW",
      CREATECONDITIONSVIEW: "CREATECONDITIONSVIEW",
      conditions: [
        { key: "Greater Than", value: ">" },
        { key: "Less Than", value: "<" },
        { key: "Equals To", value: "=" },
        { key: "Greater Than or Equals To", value: ">=" },
        { key: "Less Than or Equals To", value: "<=" },
        { key: "Not Equal To", value: "!=" },
      ],
      priorities: [
        { key: "Critical", value: 1 },
        { key: "High", value: 2 },
        { key: "Medium", value: 3 },
        { key: "Low", value: 4 },
      ],
    },
    services: {
      alertConfigurations: "/alert/configs/alerts/",
      alertConfigurationDetails: "/alert/configs/",
      updateAlertConfiguration: "/alert/configs/",
      createAlertConfiguration: "/alert/configs",
      updateAlertCondition: "/alert/conditions/",
      alertConditionDetails: "/alert/conditions/",
      createAlertCondition: "alert/conditions",
      addAlertConfigurations: "/alarm/configs",
      getAllAlarms: "/alarm/configs/alarms",
      deleteAlarms: "/alarm/configs/delete/",
      activeAlarms: "/dashboard/config/active/",
      inactiveAlarms: "/alarm/configs/inactive/",
    },
  },
  users: {
    tableHeaders: [
      "Username",
      "Email",
      "Phone",
      "Role",
      "Customer",
      "Permissions",
      "",
    ],
    customerUsersTableHeaders: [
      "Email",
      "First Name",
      "Last Name",
      "Phone",
      "Roles",
      "Membership Status",
      "Account Status",
      "Action",
    ],
    dropdown: {
      roles: [
        { label: "Administrator", value: "Administrator" },
        { label: "User", value: "User" },
      ],
    },
    services: {
      customerUsersRoot: `/${PLATFORM_ADMIN_SERVICE_V1}/customers`,
      createUser: `/${PLATFORM_ADMIN_SERVICE_V1}/users`,
      usersExists: `/${PLATFORM_ADMIN_SERVICE_V1}/users/exists`,
      userIdentifierExists: `/${PLATFORM_ADMIN_SERVICE_V1}/users/identifier/exists`,
      platformUsers: `/${PLATFORM_ADMIN_SERVICE_V1}/users`,
      userInvites: `/${PLATFORM_ADMIN_SERVICE_V1}/userInvites`,
      userInviteValidate: `/${PLATFORM_ADMIN_SERVICE_V1}/userInvites/validate`,
      inviteAcceptances: `/${PLATFORM_ADMIN_SERVICE_V1}/inviteAcceptances`,
      validateUser: `/${PLATFORM_ADMIN_SERVICE_V1}/users/cognito/`,
      validateEmail: `/${PLATFORM_ADMIN_SERVICE_V1}/users/cognito/email/`,
      validateMobilenumber: `/${PLATFORM_ADMIN_SERVICE_V1}/users/cognito/mobilenumber/`,
      validateUserInGroup: `/${PLATFORM_ADMIN_SERVICE_V1}/users/group/cognito/`,
    },
    constants: {
      platformRoles: [
        { label: "None", value: "None" },
        { label: "PlatformAdmin", value: "PlatformAdmin" },
      ],
      customerAccessRoles: [
        { label: "SupportAdmin", value: "SupportAdmin" },
        { label: "Admin", value: "Admin" },
        { label: "Supervisor", value: "Supervisor" },
        { label: "Operator", value: "Operator" },
        { label: "ViewOnly", value: "ViewOnly" },
      ],
      PASSWORDALERT: `Password must contain at least 1 uppercase letter, 1 special
        character, and 1 digit. The minimum length of the password is 8
        characters.`,
    },
  },
  userRoutes: {
    userAdminRoutes: {
      headerTitle: "Administration",
      headerButton: {
        label: "Return to Application",
        onClickHandler: () => {
          window.location.href = `${base_url}/live`;
        },
      },
      accessiblePages: [
        {
          label: "USER MANAGEMENT",
          component: Users,
          pageKey: "userManagement",
        },
      ],
    },
    superAdminRoutes: {
      headerTitle: "Platform Administration",
      accessiblePages: [
        {
          label: "CUSTOMERS",
          component: Groups,
          pageKey: "customer",
        },
        {
          label: "CONFIGURATIONS",
          component: ThingType,
          pageKey: "configurations",
        },
        {
          label: "USER ACCESS",
          component: PlatformUserAccess,
          pageKey: "userAccessControl",
        },
      ],
    },
  },
  routes: {
    userAdminRoutes: [
      { label: "ALL", value: "All", route: "/home" },
      // { label: "ASSETS", value: "Assets", route: "/assets" },
      {
        label: "DATA MANAGEMENT",
        value: "DataManagement",
        route: "/administration",
      },
      { label: "USER MANAGEMENT", value: "Admin", route: "/admin" },
      {
        label: "DASHBOARD",
        value: "Dashboard",
        route: `${base_url}/live`,
      },
    ],
    superAdminRoutes: [
      { label: "CUSTOMERS", value: "Groups", route: "/customers" },
      // { label: "USERS", value: "CreateUser", route: "/createuser" },
      { label: "CONFIGURATIONS", value: "ThingType", route: "/thingtype" },
      {
        label: "USER ACCESS",
        value: "PlatformUserAccess",
        route: "/user-access",
      },
      { label: "ALL", value: "All", route: "/home" },
    ],
  },
  thingTypeDetails: {
    tableHeaders: {
      thingType: ["Asset Type", "Display Page", "Status"],
      category: [
        { title: "Category Name" },
        { title: "Description" },
        { title: "Status" },
      ],
      alertResponse: [
        { title: "Alert Response", width: "col-2" },
        { title: "Alert Response Message", width: "col-6" },
        { title: "Status", width: "col-1" },
        { title: "", width: "col-1" },
      ],
    },
    constants: {
      THINGTYPELISTVIEW: "THINGTYPELISTVIEW",
      ADDTHINGTYPEVIEW: "ADDTHINGTYPEVIEW",
      EDITTHINGTYPEVIEW: "EDITTHINGTYPEVIEW",
      THINGTYPEPREVIEW: "THINGTYPEPREVIEW",
    },

    displayPages: [
      { label: "Select", value: "" },
      { label: "Main Page", value: "Main Page" },
      { label: "Site", value: "Site" },
      { label: "Equipment(Asset)", value: "Equipment(Asset)" },
      { label: "Sensor", value: "Sensor" },
    ],
    alertResponse: [
      { label: "Acknowledge", value: "A" },
      { label: "Dismiss", value: "D" },
    ],
    services: {
      thingTypeCategoryDetails: "/things/type/details",
      getThingCategoryByID: "things/type/preview/",
      createThingType: "things/type",
      editThingType: "things/type/",
      changeThingTypeStatus: "things/type/update/",
      createThingTypeImage: "things/image",
      thingTypeImages: "/things/image/typeid/",
    },
  },
  groups: {
    tableHeaders: {
      list: ["Customer Name", "Customer ID", "Status"],
      kafka: ["Topic Name", "Publisher", "Topic Type", "Status"],
      schema: [
        "Database Type",
        "Database Name",
        "WaterMinds Schema",
        "WaterMinds User Name",
        "AWS Secret Key",
      ],
    },
    dropdown: {
      partition: [
        { label: "Weekly", value: "weekly" },
        { label: "Monthly", value: "monthly" },
      ],
      timeZone: [
        { label: "America/Anchorage - UTC−09:00 / UTC−08:00", value: "US/Alaska" },
        { label: "America/Phoenix - UTC−07:00 (no DST)", value: "US/Arizona" },
        { label: "America/Chicago - UTC−06:00 / UTC−05:00", value: "US/Central" },
        { label: "America/New_York - UTC−05:00 / UTC−04:00", value: "US/Eastern" },
        { label: "Pacific/Honolulu - UTC−10:00 (no DST)", value: "US/Hawaii" },
        { label: "America/Los_Angeles - UTC−08:00 / UTC−07:00", value: "US/Pacific" },
        { label: "Pacific/Pago_Pago - UTC−11:00 (no DST)", value: "US/Samoa" },
        { label: "America/Puerto_Rico - UTC−04:00 (no DST)", value: "America/Puerto_Rico" },
        { label: "America/St_Thomas - UTC−04:00 (no DST)", value: "America/St_Thomas" },
        { label: "Pacific/Guam - UTC+10:00 (no DST)", value: "Pacific/Guam" },
        { label: "America/Denver - UTC−07:00 / UTC−06:00", value: "America/Denver" },
      ],
    },
    constants: {
      GROUPLISTVIEW: "GROUPLISTVIEW",
      GROUPCREATEVIEW: "GROUPCREATEVIEW",
      GROUPEDITEVIEW: "GROUPEDITEVIEW",
      GROUPPREVIEW: "GROUPPREVIEW",
    },
    services: {
      groupsList: "/platform-admin-service/v1/customers",
      editGroup: "/platform-admin-service/v1/customers/",
      patchGroup: "/platform-admin-service/v1/customers/",
      createGroup: "/platform-admin-service/v1/customers",
      activeGroups: "/platform-admin-service/v1/customers/active",
      hachwimsFacilityOptions: "/platform-admin-service/v1/facilities",
      customerRoles: "/platform-admin-service/v1/customerRoles",
    },
  },
  login: {
    services: {
      userAccessInfo: `/${PLATFORM_ADMIN_SERVICE_V1}/users/details`,
      me: `/${PLATFORM_ADMIN_SERVICE_V1}/me`,
      meCustomerAccess: `/${PLATFORM_ADMIN_SERVICE_V1}/me/customerAccess`,
      meActiveCustomer: `/${PLATFORM_ADMIN_SERVICE_V1}/me/activeCustomer`,
      meEffectiveAccess: `/${PLATFORM_ADMIN_SERVICE_V1}/me/effectiveAccess`,
    },
  },
  userRole: {
    PlatformAdmin: 1,
    SuperAdmin: 1,
    Admin: 2,
    User: 3,
    Unknown: 0,
  },
  selectedCustomer: {
    noCustomerSelected: "No Customer Selected",
    viewing: "Viewing:",
  },
  tabNames: {
    dataManagement: "Data Management",
  },
  subTabNames: {
    edgeHierarchy: "Edge Hierarchy",
    cloudHierarchy: "Cloud Hierarchy",
    tags: "Tags",
    imports: "Imports",
  },
  dataManagement: {
    subTabKeys: ["edgeHierarchy", "cloudHierarchy", "tags", "imports"],
  },
  navigationRoutes: {
    administration: "/administration",
    cloudHierarchy: "/cloud-hierarchy",
  },
  cloudView: {
    unsChildTypesByParentThingType: {
      Customer: ["Location"],
      Location: ["Area", "Edge Node", "Equipment"],
      Area: ["Area", "Edge Node", "Equipment"],
      "Process Area": ["Area", "Edge Node", "Equipment"],
      "Edge Node": ["Equipment", "Metric"],
      Equipment: ["Metric", "Others"],
      Metric: [],
      Others: [],
    },
    thingTypesWithOptionalTagField: ["Metric", "Tag", "Control"],
  },
};

export default INFRAMARK_CONSTANTS;